import {
  setAccountCtxMenu,
  setCreateCtxMenu,
  setHelpCtxMenu,
  setNavLeftMenu
} from '../../redux/slices/config-slice'
import { useDispatch } from 'react-redux'

export function useCloseContextMenus(): () => void {
  const dispatch = useDispatch()

  const closeContextMenus = (): void => {
    dispatch(
      setNavLeftMenu({
        open: false
      })
    )
    dispatch(setAccountCtxMenu({ open: false }))
    dispatch(setHelpCtxMenu({ open: false }))
    dispatch(setCreateCtxMenu({ open: false }))
  }
  return closeContextMenus
}
